import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Card } from '@/components/ui/card';
import { RefreshCw } from 'lucide-react';

export function LoopNode({ data, selected }: any) {
  const interval = data?.interval_seconds || 60;
  const timeout = data?.timeout_minutes || 60;
  const condition = data?.condition;
  const conditionValues: string[] = Array.isArray(condition?.values) && condition.values.length > 0
    ? condition.values
    : (condition?.value != null && condition.value !== '' ? [condition.value] : []);
  const valueText = conditionValues.length > 2
    ? `${conditionValues.slice(0, 2).join(', ')} +${conditionValues.length - 2}`
    : conditionValues.join(', ');
  const subtitle = condition?.field
    ? `until ${condition.field} ${condition.operator || 'equals'}${valueText ? ` ${valueText}` : ''} · every ${interval}s, up to ${timeout}m`
    : `every ${interval}s, up to ${timeout}m`;
  return (
    <div className="relative">
      <Handle type="target" position={Position.Left} className="!bg-primary !w-2 !h-2" />
      <Handle type="source" position={Position.Right} id="met" style={{ top: '35%' }} className="!bg-green-500 !w-2 !h-2" />
      <Handle type="source" position={Position.Right} id="timeout" style={{ top: '65%' }} className="!bg-red-500 !w-2 !h-2" />
      <Card
        className={`w-[260px] p-3 border-2 transition-shadow cursor-pointer ${
          selected ? 'border-primary shadow-lg ring-2 ring-primary/20' : 'border-zinc-300 dark:border-zinc-700'
        } bg-zinc-50 dark:bg-zinc-900/40`}
      >
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-zinc-100 dark:bg-zinc-800 shrink-0">
            <RefreshCw className="w-4 h-4 text-zinc-900 dark:text-zinc-100" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-1">
              <div className="text-xs font-medium text-zinc-500 dark:text-zinc-400 uppercase tracking-wide truncate">Poll Until</div>
              <div className="flex items-center gap-1 text-[10px] font-medium shrink-0">
                <span className="text-green-600 dark:text-green-400">Met</span>
                <span className="text-zinc-400 dark:text-zinc-600">/</span>
                <span className="text-red-600 dark:text-red-400">Timeout</span>
              </div>
            </div>
            <div className="text-sm font-semibold truncate">{data.label || 'Poll Until'}</div>
            <div className="text-[11px] text-zinc-500 dark:text-zinc-400 truncate" title={subtitle}>{subtitle}</div>
          </div>
        </div>
      </Card>
    </div>
  );
}
